import type {
  SeverityLevel,
  Scope,
  EventHint,
  BrowserClient,
} from '@sentry/browser';
import { withScope as withScopeFromSentry } from '@sentry/browser';
import { getClientFor } from './getClientFor';
import type { AppContext } from './types/AppContext';
import { defaultAppContext } from '.';

type ReportMessageDependencies = {
  client?: BrowserClient;
  appContext?: AppContext;
  level?: SeverityLevel;
  location?: Location;
  withScope?: typeof withScopeFromSentry;
};

export const reportMessage =
  ({
    client = getClientFor(),
    appContext = defaultAppContext,
    level,
    location = window.location,
    withScope = withScopeFromSentry,
  }: ReportMessageDependencies) =>
  (message: string, hint?: EventHint): void => {
    withScope((scope: Scope) => {
      scope.setTransactionName(`${appContext.app_name}@${location.host}`);
      scope.setContext('app', appContext);

      if (hint?.data?.user) {
        scope.setUser(hint.data.user);
      }

      client.captureMessage(message, level, hint, scope);
    });
  };
